import React from 'react';

function HomeIcon({ className = '' }) {
	return (
		<svg
			className={className}
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<g clipPath='url(#clip0_907_55697)'>
				<path
					d='M8.91679 14.2688H4.29919V18.8704H8.91679V14.2688Z'
					fill='#CF004F'
				/>
				<path
					d='M8.91679 19.4224H4.29919V24.024H8.91679V19.4224Z'
					fill='#CF004F'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M24 10.5248V24.024H20.1168V17.1248H15.4528V24.024H12.4896V13.04H3V24.024H0V10.5248L12.3872 0.0240479L24 10.5248Z'
					fill='#CF004F'
				/>
			</g>
			<defs>
				<clipPath id='clip0_907_55697'>
					<rect width='24' height='24' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
}

export default HomeIcon;
